import { atendimento } from "../requests/atendimento";
import ApiCentralAjuda from "./ApiCentralAjuda";

export const CentralAjudaService = {
    getToken: (identity: string) => {
        return ApiCentralAjuda.get("/getToken", {
            params: {
                identity: identity,
            },
        });
    },
    validateToken: (token: string) => {
        return ApiCentralAjuda.post("/validateToken", {
            token: token,
        });
    },

    atendimento: atendimento

};
